import React from "react";
import CustomButton from "../../../../common/CustomButton";
import AsteriskStyle from "../../../../Form/Tooltip/AsteriskStyle";
import { formatIndianCurrency, numberToWords } from "../../../../../Enum";

const ChargesStep = ({
  selectedPropertyType,
  unitInfo,
  formData,
  parkingOptions,
  onInputChange,
  onDownload,
  totalPrice,
  loading
}) => {

  const restrictToTenDigits = (value, callback) => {
    if (value === "" || (value.toString().length <= 10 && !isNaN(value))) {
      callback(value);
    }
  };

  return (
    <div className="flex gap-7">
      {selectedPropertyType !== "Layout" && (
        <div className="bg-green-100 rounded-[10px] p-4 w-1/3 h-[300px]">
          <h2 className="text-lg font-semibold mb-3">Unit Info</h2>
          <div className="space-y-1 text-sm text-gray-800">
            <p>
              <span className="font-medium">Saleable Area:</span>{" "}
              {unitInfo?.saleableArea || "N/A"}
            </p>
            {selectedPropertyType === "Villa" && (
              <p>
                <span className="font-medium">Total Floor:</span>{" "}
                {unitInfo?.floors || "N/A"}
              </p>
            )}
            {selectedPropertyType === "Apartment" && (
              <p>
                <span className="font-medium">Unit Floor:</span>{" "}
                {unitInfo?.unitFloor || "N/A"}
              </p>
            )}
            <p>
              <span className="font-medium">Total BHK:</span>{" "}
              {unitInfo?.totalBhk || "N/A"}
            </p>
            <p>
              <span className="font-medium">Fully Covered Parking:</span>{" "}
              {parkingOptions.fullyCovered}
            </p>
            <p>
              <span className="font-medium">Semi Covered Parking:</span>{" "}
              {parkingOptions.semiCovered}
            </p>
            <p>
              <span className="font-medium">Open Parking:</span>{" "}
              {parkingOptions.open}
            </p>
            <p>
              <span className="font-medium">Unit Facing Side:</span>{" "}
              {unitInfo?.roadFacingSide?.name || "N/A"}
            </p>
            <p>
              <span className="font-medium">Furnishe type:</span>{" "}
              {formData.selectedFurnished || "N/A"}
            </p>
          </div>
        </div>
      )}

      <div
        className={`flex flex-col gap-5 ${
          selectedPropertyType === "Layout" ? "w-full" : "w-2/3"
        }`}
      >
        {selectedPropertyType === "Layout" ? (
          <>
            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Price Per Sq.ft <AsteriskStyle />
              </label>
              <div className="col-span-8 relative">
                <input
                  type="number"
                  min={0}
                  value={unitInfo?.ratePerSqft || ""}
                  onChange={(e) => restrictToTenDigits(e.target.value, (value) => onInputChange("ratePerSqft", value))}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="Base Rate"
                />
                <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
                  In RS
                </span>
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Preferred Location Charge 
              </label>
              <div className="col-span-8 relative">
                <input
                  type="number"
                  min={0}
                  value={unitInfo?.preferredLocationCharge || ""}
                  onChange={(e) => restrictToTenDigits(e.target.value, (value) => onInputChange("preferredLocationCharge", value))}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="Preferred Location Charge"
                />
                <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
                  In RS
                </span>
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                GST 
              </label>
              <div className="col-span-8 relative">
                <input
                  type="number"
                  value={unitInfo?.gst || ""}
                  min={0}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      value === "" ||
                      (/^\d{0,2}(\.\d{0,2})?$/.test(value) &&
                        Number(value) >= 0 &&
                        Number(value) <= 100)
                    ) {
                      restrictToTenDigits(value, (val) => onInputChange("gst", val));
                    }
                  }}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="eg: 18 Percentage"
                />
                <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
                  In %
                </span>
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Registration Fee 
              </label>
              <div className="col-span-8 relative">
                <input
                  type="number"
                  value={unitInfo?.registrationCharge || ""}
                  onChange={(e) => restrictToTenDigits(e.target.value, (value) => onInputChange("registrationCharge", value))}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="Registration Fees"
                />
                <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
                  In RS
                </span>
              </div>
            </div>
            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Survey Fee 
              </label>
              <div className="col-span-8 relative">
                <input
                  type="number"
                  value={unitInfo?.surveyFee || ""}
                  min={0}
                  onChange={(e) => restrictToTenDigits(e.target.value, (value) => onInputChange("surveyFee", value))}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="Survey Fees"
                />
                <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
                  In RS
                </span>
              </div>
            </div>
            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Document Charge 
              </label>
              <div className="col-span-8 relative">
                <input
                  type="number"
                  value={unitInfo?.documentCharge || ""}
                  min={0}
                  onChange={(e) => restrictToTenDigits(e.target.value, (value) => onInputChange("documentCharge", value))}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="Document Charges"
                />
                <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
                  In RS
                </span>
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Total Price
              </label>
              <div className="col-span-8">
                <input
                  type="text"
                  value={`${formatIndianCurrency(totalPrice)}`}
                  readOnly
                  className="w-full focus:outline-none px-3 py-2 bg-slate-100 rounded-md text-gray-800 font-medium"
                />
                <div className="text-xs text-customGreen mt-2 ">({numberToWords(totalPrice)})</div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Base Rate <AsteriskStyle />
              </label>
              <div className="col-span-8 relative">
                <input
                  type="number"
                  value={unitInfo?.baseRate || ""}
                  onChange={(e) => restrictToTenDigits(e.target.value, (value) => onInputChange("baseRate", value))}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="Base Rate"
                />
                <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
                  In RS
                </span>
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Preferred Location Charge 
              </label>
              <div className="col-span-8 relative">
                <input
                  type="number"
                  value={unitInfo?.preferredLocationCharge || ""}
                  onChange={(e) => restrictToTenDigits(e.target.value, (value) => onInputChange("preferredLocationCharge", value))}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="Preferred Location Charge"
                />
                <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
                  In RS
                </span>
              </div>
            </div>

            {parkingOptions.fullyCovered > 0 && (
              <div className="grid grid-cols-12 items-center">
                <label className="col-span-4 text-sm font-medium text-gray-700">
                  Fully Covered Parking ({parkingOptions.fullyCovered}){" "}
                  <AsteriskStyle />
                </label>
                <div className="col-span-8 relative">
                  <input
                    type="number"
                    value={unitInfo?.fullyCoveredParkingCharge * parkingOptions.fullyCovered || ""}
                    min={0}
                    onChange={(e) => restrictToTenDigits(e.target.value, (value) => onInputChange("fullyCoveredParkingCharge", value))}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                    placeholder="Fully Covered Parking Charge"
                  />
                  <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
                    In RS
                  </span>
                </div>
              </div>
            )}

            {parkingOptions.semiCovered > 0 && (
              <div className="grid grid-cols-12 items-center">
                <label className="col-span-4 text-sm font-medium text-gray-700">
                  Semi Covered Parking ({parkingOptions.semiCovered}){" "}
                  <AsteriskStyle />
                </label>
                <div className="col-span-8 relative">
                  <input
                    type="number"
                    value={unitInfo?.semiCoveredParkingCharge * parkingOptions.semiCovered || ""}
                    min={0}
                    onChange={(e) => restrictToTenDigits(e.target.value, (value) => onInputChange("semiCoveredParkingCharge", value))}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                    placeholder="Semi Covered Parking Charge"
                  />
                  <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
                    In RS
                  </span>
                </div>
              </div>
            )}

            {parkingOptions.open > 0 && (
              <div className="grid grid-cols-12 items-center">
                <label className="col-span-4 text-sm font-medium text-gray-700">
                  Open Parking ({parkingOptions.open}) <AsteriskStyle />
                </label>
                <div className="col-span-8 relative">
                  <input
                    type="number"
                    value={unitInfo?.openParkingCharge * parkingOptions.open || ""}
                    onChange={(e) => restrictToTenDigits(e.target.value, (value) => onInputChange("openParkingCharge", value))}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                    placeholder="Open Parking Charge"
                  />
                  <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
                    In RS
                  </span>
                </div>
              </div>
            )}

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                GST 
              </label>
              <div className="col-span-8 relative">
                <input
                  type="number"
                  value={unitInfo?.gst || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      value === "" ||
                      (/^\d{0,2}(\.\d{0,2})?$/.test(value) &&
                        Number(value) >= 0 &&
                        Number(value) <= 100)
                    ) {
                      restrictToTenDigits(value, (val) => onInputChange("gst", val));
                    }
                  }}
                  min={0}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="eg: 18 Percentage"
                />
                <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
                  In %
                </span>
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Electricity Charges 
              </label>
              <div className="col-span-8 relative">
                <input
                  type="number"
                  value={unitInfo?.electricityCharge || ""}
                  onChange={(e) => restrictToTenDigits(e.target.value, (value) => onInputChange("electricityCharge", value))}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="Electricity Charge"
                />
                <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
                  In RS
                </span>
              </div>
            </div>
            {formData.selectedFurnished !== "Unfurnished" && (
              <div className="grid grid-cols-12 items-center">
                <label className="col-span-4 text-sm font-medium text-gray-700">
                  {formData.selectedFurnished} Charge <AsteriskStyle />
                </label>
                <div className="col-span-8 relative">
                  <input
                    type="number"
                    value={unitInfo?.furnishedCharge || ""}
                    onChange={(e) => restrictToTenDigits(e.target.value, (value) => onInputChange("furnishedCharge", value))}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    min={0}
                    className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                    placeholder="Furnished Charge"
                  />
                  <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
                    In RS
                  </span>
                </div>
              </div>
            )}

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Registration Fee 
              </label>
              <div className="col-span-8 relative">
                <input
                  type="number"
                  value={unitInfo?.registrationCharge || ""}
                  onChange={(e) => restrictToTenDigits(e.target.value, (value) => onInputChange("registrationCharge", value))}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="Registration Fees"
                />
                <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
                  In RS
                </span>
              </div>
            </div>

            {/* {selectedPropertyType !== "Apartment" && ( */}
              <div className="grid grid-cols-12 items-center">
                <label className="col-span-4 text-sm font-medium text-gray-700">
                  Survey Fee 
                </label>
                <div className="col-span-8 relative">
                  <input
                    type="number"
                    value={unitInfo?.surveyFee || ""}
                    onChange={(e) => restrictToTenDigits(e.target.value, (value) => onInputChange("surveyFee", value))}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    min={0}
                    className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                    placeholder="Survey Fees"
                  />
                  <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
                    In RS
                  </span>
                </div>
              </div>
            {/* )} */}

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Document Charge
              </label>
              <div className="col-span-8 relative">
                <input
                  type="number"
                  value={unitInfo?.documentCharge || ""}
                  onChange={(e) => restrictToTenDigits(e.target.value, (value) => onInputChange("documentCharge", value))}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="Document Charges"
                />
                <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
                  In RS
                </span>
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Total Price
              </label>
              <div className="col-span-8">
                <input
                  type="text"
                  value={`${formatIndianCurrency(totalPrice)}`}
                  readOnly
                  className="w-full focus:outline-none px-3 py-2 bg-slate-100 rounded-md text-gray-800 font-medium"
                />
                <div className="text-xs text-customGreen mt-2 ">({numberToWords(totalPrice)})</div>
              </div>
            </div>

          </>
        )}

        <div className="flex justify-center mt-3">
          <CustomButton
            label={"Download Estimate"}
            onClick={onDownload}
            isDisabled={loading}
            className={"w-[320px] nataural"}
          />
        </div>
      </div>
    </div>
  );
};

export default ChargesStep;